import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import AppComponent from './AppComponent';

import { registerServiceWorker } from './registerServiceWorker';
// Удаляем скрипт регистрации из HTML и делаем его здесь
window.addEventListener('load', () => {
	registerServiceWorker();
});

const container = document.getElementById('root');
if (!container) {
	throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
	<React.StrictMode>
		<AppComponent />
	</React.StrictMode>
);

import "./metrika";